import { HttpInterceptors } from "./http.interceptor";

export class AccountClassService extends HttpInterceptors {
	async listAccountClass (filters) {
		const response = await this.axios.get("accountClass/listAccountClass", { params: { filters } });
		return response.data;
	}

	async upsertAccountClass (payload) {
		const response = await this.axios.post("accountClass/upsertAccountClass", payload);
		return response.data;
	}

	async deleteAccountClass (id) {
		const response = await this.axios.delete("accountClass/deleteAccountClass", { params: id });
		return response.data;
	}
}
